import script from "./AdministratorReportRejectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorReportRejectForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorReportRejectForm.vue?vue&type=style&index=0&id=7aa8a25a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa8a25a"]])

export default __exports__